import { render } from "./MicrophoneProblem.vue?vue&type=template&id=62526b42&scoped=true"
import script from "./MicrophoneProblem.vue?vue&type=script&lang=js"
export * from "./MicrophoneProblem.vue?vue&type=script&lang=js"

import "./MicrophoneProblem.vue?vue&type=style&index=0&id=62526b42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62526b42"

export default script